/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { classnames as cx, propsUtils } from '@ba-ui-toolkit/utils';

import styles from './Paragraph.scss';

const paragraphClassName = styles.paragraphClassName.replace(/"/g, '');
const { sanitize } = propsUtils;

export default class Paragraph extends Component {
	static propTypes = {
		/** Children to be inserted in the paragraph tag */
		children: PropTypes.node,
		/** Function that will get called on click of Paragraph component */
		onClick: PropTypes.func,
		/** Style object to be passed as the inline styling */
		style: PropTypes.object,
		/** Name of class to be applied to component */
		className: PropTypes.string,
		/** Change the font weight of the component */
		fontWeight: PropTypes.oneOf(['normal', 'bold']),
		/** Change the font size of the component */
		fontSize: PropTypes.oneOf(['small', 'normal']),
		/** Change the color of the text to primary */
		primary: PropTypes.bool,
	};

	static defaultProps = {
		style: {},
		className: '',
		primary: false,
	};

	render() {
		const {
			children,
			onClick,
			style,
			className,
			fontWeight,
			fontSize,
			primary,
			...others
		} = this.props;
		const classNames = cx(paragraphClassName, {
			[fontWeight]: fontWeight,
			[fontSize]: fontSize,
			primary,
			clickable: typeof onClick !== 'undefined',
		});

		const pProps = {
			...sanitize(others, Paragraph),
			className: `${classNames} ${className}`,
			style,
			onClick,
		};

		return <p {...pProps}>{children}</p>;
	}
}
